// App.js or UploadForm.js
import React, { useState } from 'react';
import axios from 'axios';

function UploadForm() {
  const [name, setName] = useState('');
  const [pdf, setPdf] = useState(null);
  const [message, setMessage] = useState('');

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!name || !pdf) {
      setMessage("Name and PDF file are required.");
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('pdf', pdf);

    try {
      // const response = await axios.post('http://localhost/myapp/upload.php', formData, {
      const response = await axios.post('https://spst.in/myapp/upload.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const res = response.data;
      if (res.success) {
        setMessage("Upload successful: " + res.data.filePath);
        window.location.reload();
      } else {
        setMessage("Error: " + res.message);
      }
    } catch (err) {
      console.error(err);
      setMessage("An error occurred during upload.");
    }
  };
  

  return (
    <div >
          <h4 style={{marginBottom:'6px',fontWeight:'600',paddingBottom:'6px'}}>Latest Updates</h4>
					<form onSubmit={handleUpload}>
            <div className="row">
              <div className="col-md-12" style={{marginBottom:'15px'}}>
                  <textarea className="form-control textlatest"
                  type="text"
                 
                  placeholder="Enter Tender Title"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  ></textarea>
              </div>
              <div className="col-md-12" style={{marginBottom:'15px'}}>
                  <input className="form-control fileupload"
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setPdf(e.target.files[0])}
                  />
              </div>
              <div className="col-md-12">
                  <button type="submit" className="btn btn-primary firstbuttoncolor">Upload</button>
              </div>
            </div>
				</form>
				<p>{message}</p>
				</div>
  );
}

export default UploadForm;
